import { FC } from 'react'
import theme from 'theme'

/* Components */
import WaveSkeleton from './WaveSkeleton'

const StubCategoriesSection: FC = () => (
  <WaveSkeleton height={232} sx={{ borderRadius: theme.attributes.borderRadius.quaternary }} />
)

export default StubCategoriesSection
